<template>
    <div>
        <label class="form-group__label form-group__label--checkbox">
            <input
                type="checkbox"
                class="form-group__checkbox"
                :value="userSubscribe"
                @input="$emit('update:userSubscribe', $event.target.checked)" />
            <span :class="labelClass"
                >{{ $t("agree_i_give") }}
                <a
                    href="https://post-post-scriptum.com/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                    target="_blank"
                    >{{ $t("agree_agree") }}</a
                >
                {{ $t("agree_pd") }}
                <a href="https://post-post-scriptum.com/dokumenty/politika-konfidencialnosti/" target="_blank">{{
                    $t("agree_pd_pd")
                }}</a></span
            >
        </label>
        <label class="form-group__label form-group__label--checkbox">
            <input
                type="checkbox"
                class="form-group__checkbox"
                :value="userSubscribeAd"
                @input="$emit('update:userSubscribeAd', $event.target.checked)" />
            <span :class="labelClass"
                >{{ $t("agree_i_give") }}
                <a
                    href="https://post-post-scriptum.com/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                    target="_blank"
                    >{{ $t("agree_agree") }}</a
                >
                {{ $t("agree_ms") }}
                <a
                    href="https://post-post-scriptum.com/dokumenty/soglasie-na-informacionnuyu-i-reklamnuyu-rassylku/"
                    target="_blank"
                    >{{ $t("agree_ms_ms") }}</a
                ></span
            >
        </label>
    </div>
</template>
<script>
export default {
    name: "AgreenemtCheckboxses",
    props: {
        labelClass: {
            type: String,
            default: "text_13",
        },
        userSubscribe: {
            type: Boolean,
            default: false,
        },
        userSubscribeAd: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style scoped>
.form-group__label {
    margin-top: 16px;
}
.form-group__label--checkbox + .form-group__label--checkbox {
    margin-top: 16px;
    margin-left: 0;
}
</style>
